import { LoaderFunctionArgs } from "react-router-dom";
import { Api         } from "../api/Api";
import { DatasetImage } from "../api/Application";
import { paramIds } from "../api/ApiUtil";

export async function datasetImageListLoader( { params }: LoaderFunctionArgs ): Promise<DatasetImage[]> {
    const { datasetId } = paramIds( params );
    const result = await Api.datasetImageList( datasetId );
    if( result.isOk ) {
        return result.value;
    }    
    throw new Error( "Couldn't load Dataset Images" );
}